import { render } from "./InputFileImage.vue?vue&type=template&id=6165c19f"
import script from "./InputFileImage.vue?vue&type=script&lang=js"
export * from "./InputFileImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__